import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Title } from "../../Utils/UI/Text";
import { getLogs, getLog } from "../Application/Logs.business";
import { getLogsSelector } from "../Infrastructure/Logs.reducer";
import LogsBoard from "./LogsBoard";
import { useParams } from "react-router-dom";
import "./Logs.css";

export default function Logs() {
  const logs = useSelector(getLogsSelector);
  const { id } = useParams();

  useEffect(() => {
    getLogs();
    if (id) {
      getLog(id);
    }
  }, [id]);
  return (
    <>
      <Title children=" Carbon Credit records (logs)" />

      <LogsBoard logs={logs} getLog={getLog} getLogs={getLogs} />
    </>
  );
}
